// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@wix/yoshi-style-dependencies/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@wix/yoshi-style-dependencies/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wmg0tH{min-height:54px}.UOUlb9{opacity:1}.IPdeFn{opacity:0;height:0;padding-top:0;padding-bottom:0;transition:all 250ms}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"itemContainer": `wmg0tH`,
	"fadeAndSlideOut": `UOUlb9`,
	"fadeAndSlideOutActive": `IPdeFn`
};
export default ___CSS_LOADER_EXPORT___;
